import React, { useState, useEffect } from "react";
import "./allpages.css";
import useEncryption from "../../../services/useEncryption";
import { getAllNotesApi } from "../../../api/userApi/userApi";
import useHeaders from "../../../helpers/useHeaders";
import moment from "moment-timezone";
import customEdit from "../../../assets/images/authimgs/editicon.svg";
import customDelete from "../../../assets/images/authimgs/deleteicon.svg";
import useToast from "../../../helpers/useToast";
import { toast } from "react-toastify";
import { deleteNoteApi } from "../../../api/userApi/userApi";
import UpdateNotesModal from "./UpdateNotesModal";
import DeleteDialogBox from "../../../components/dialogBox/DeleteDialogBox";
import { createAuditLogs } from "../../../api/providerApi/providerApi";
import { useSelector } from "react-redux";
import { selectAuth } from "../../../redux/slice/authSlice";

const Notes = ({ leadId, setOpen, updatedNotes }) => {
  const { encryptData, decryptData } = useEncryption();
  const userRole = useSelector((state) => state.auth.role);
  const headers = useHeaders();
  const toastOptions = useToast();
  const [notesData, setNotesData] = useState(null);
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [selectedNote, setSelectedNote] = useState(null);
  const [notesAction, setNotesAction] = useState(false);
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);
  const [noteToDelete, setNoteToDelete] = useState(null);
  const { role } = useSelector(selectAuth);

  const formatDate = (isoDateString) => {
    return moment(isoDateString)
      .tz("America/New_York")
      .format("MMM D YYYY, h:mm a (z)");
  };
  useEffect(() => {
    if (!leadId) return;

    const fetchData = async () => {
      try {
        const response = await getAllNotesApi(leadId, headers);
        const decryptedData = decryptData(response.data.data);
        const sortedNotes = decryptedData.sort(
          (a, b) => new Date(b.updated_at) - new Date(a.updated_at)
        );
        setNotesData(sortedNotes);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [leadId, updatedNotes, notesAction]);

  const handleClick = () => {
    setOpen(true);
  };

  const handleEdit = (noteId) => {
    const noteToEdit = notesData.find((note) => note._id === noteId);
    setSelectedNote(noteToEdit);
    setIsEditOpen(true);
  };

  const handleDelete = async (noteId) => {
    try {
      const response = await deleteNoteApi(noteToDelete._id, headers);
      toast.success(response.data.message, toastOptions);
      let obj = {
        event: `${role} has deleted the Note for lead.`,
      };
      await createAuditLogs({ data: encryptData(obj) }, headers);
      setNotesAction((prev) => !prev);
      setIsDeleteOpen(false);
    } catch (error) {
      toast.error(error.response.data.message, toastOptions);
    }
  };

  const handleEditClose = () => {
    setIsEditOpen(false);
    setSelectedNote(null);
    setNotesAction((prev) => !prev);
  };

  const handleDeleteClick = (noteId) => {
    const noteToDelete = notesData.find((note) => note._id === noteId);
    setNoteToDelete(noteToDelete);
    setIsDeleteOpen(true);
  };

  const handleDeleteClose = () => {
    setIsDeleteOpen(false);
  };

  return (
    <div className="notesblocked">
      <h6>Notes</h6>
      <hr className="lineControls" />
      {/* {(userRole === "doctor" || userRole === "provider" || userRole === "location" )&&( */}
      <button
        className="btn btn-blacked w-100 smallnotes "
        onClick={handleClick}
      >
        + Add Note
      </button>
      {/* // )} */}
      <div className="notesContainer">
        {notesData && notesData.length > 0 ? (
          notesData.map((note, index) => (
            <div className="notebox">
              <div key={index} className="notetext">
                <p>{note.notes}</p>
                <hr className="lineControls" />
                <div className="caretiondeatils newcaretiondeatils">
                  <div>
                    <div>Created: {formatDate(note.updated_at)}</div>
                    <div>By: {note.userName}</div>
                  </div>
                  {/* {(userRole === "doctor" || userRole === "provider" || userRole === "location")&&( */}
                  <div className="edit-delete-actions">
                    <img
                      width={"20px"}
                      src={customEdit}
                      alt="edit"
                      onClick={() => handleEdit(note._id)}
                    />
                    <img
                      width={"20px"}
                      src={customDelete}
                      alt="delete"
                      onClick={() => handleDeleteClick(note._id)}
                    />
                  </div>
                  {/* )} */}
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="notetext">
            <p className="nonotes">No notes available.</p>
          </div>
        )}
      </div>

      <UpdateNotesModal
        isEditOpen={isEditOpen}
        handleEditClose={handleEditClose}
        selectedNote={selectedNote}
      />
      <DeleteDialogBox
        isDeleteOpen={isDeleteOpen}
        onDeleteClose={handleDeleteClose}
        onConfirm={handleDelete}
        title="Confirm Deletion"
        description="Are you sure you want to delete this note?"
      />
    </div>
  );
};

export default Notes;
